<template>
  <div class="form_box">
      <div class="form_box__item">
        <div class="form_box__item__title">
          <el-upload
              class="upload-demo"
              :action="server"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="onUploadSuccess"
              :before-upload="onBeforeUpload"
              :before-remove="beforeRemove"  
              :on-error="onError"            
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList">
              <el-button size="small" type="primary" :loading="loading">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">上传复兴一号excel导出文件</div>
          </el-upload>
        </div>
        <div class="form_box__item__content">
        </div>
      </div>
      <div class="form_box__group">        
          <p class="font_small" v-html="message"></p>
      </div>

  </div>
</template>



<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "FXUserImport",
  
  mixins: [BaseVue],
  
  data() {
    return {
      server: "/api/manager/fxuser/add/file",
      loading: false,
      fileList: [],
      message: ""
    };
  },
  
  methods: {
    onUploadSuccess(r, file, fileList) {
      this.loading = false;
      if (r.success) {
        this.message = r.data;
        this.$message.success("导入成功");
      } else {
        this.message = r.data;
        this.$message.error("导入失败");
      }
    },
    
    onBeforeUpload(r) {
      this.loading = true;
    },
    
    onError(r) {
      this.$message.error("导入失败");
      this.loading = false;
    },
    
    handlePreview(r) {
      // 处理文件预览
    },
    
    handleRemove(r) {
      // 处理文件移除
    },
    
    beforeRemove(r) {
      // 文件移除前的逻辑
    },
    
    handleExceed(r) {
      // 处理文件超出限制
    }
  },
  
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>

<style scoped>
</style>